import { gql, TypedDocumentNode } from '@apollo/client'

import { LABEL_FRAGMENT } from './label'

import type { AbTestsParametersSchemaDTO } from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'

export const REFRESHER_FRAGMENT: TypedDocumentNode<AbTestsParametersSchemaDTO['refresher']> = gql`
  ${LABEL_FRAGMENT}

  fragment refresherFragment on AbTestsParametersRefresher {
    basicSettings {
      ...labelFragment
    }
    label
  }
`
